import {onFind} from "@elements/init-modules-in-scope";
import {closest, findIn, trigger, on, removeClass, addClass} from "@elements/dom-utils";

const defaultSelectors = {
    base: '.js-toggle-disabled',
    input: '.js-toggle-disabled__input',
    button: '.js-toggle-disabled__toggle'
};

export function init(selectors = defaultSelectors) {
    onFind(selectors.base, function (base) {
        let button = findIn(selectors.button, base);
        let input = findIn(selectors.input, base);
        let form = closest('form', base);

        on('click', function () {
            input.removeAttribute('disabled');
            button.setAttribute('hidden', 'hidden');

            if(form) {
                let hiddenEditInput = findIn('.js-hidden-edit-input', form);

                if(!hiddenEditInput) {
                    //add hidden input to form for backend
                    let hiddenInput = document.createElement('input');
                    hiddenInput.setAttribute('type', 'hidden');
                    hiddenInput.setAttribute('name', 'edit');
                    hiddenInput.setAttribute('value', '1');
                    hiddenInput.classList.add('js-hidden-edit-input');
                    form.appendChild(hiddenInput);
                }
            }
        }, button);
    });
}
